export function capitalizeWords(string: string) {
  return string.replace(/\b./g, (letter) => letter.toUpperCase());
}

export function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
